@if (!isLoading) {
  <div class="photo-gallery">
    @if (allowALLSharePictures()) {
      <div class="toggle-container">
        <span
          >All Images are
          @if (!allPhotosShared) {
            <b>NOT </b>
          }
          shared with Customer Portal by default</span
        ><mat-slide-toggle
          [checked]="allPhotosShared"
          (change)="onShareAllPhotos($event)"
        ></mat-slide-toggle>
      </div>
    }
    <div class="filter-header">
      <mat-form-field>
        <mat-label>Tags</mat-label>
        <mat-select [formControl]="selectedTags" multiple>
          <mat-select-trigger>
            @for (tag of selectedTags.value; track tag) {
              <mat-chip color="primary">
                {{ tag.name }}
                <button (click)="removeTag(tag.id)" matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            }
          </mat-select-trigger>
          @for (tag of tagsList; track tag) {
            <mat-option [value]="tag">{{ tag.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="dateInput">
        <mat-label>Date Range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input
            [value]="creationDateFrom"
            (dateChange)="onStartDateChange($event)"
            matStartDate
            placeholder="Start date"
          />
          <input
            [value]="creationDateTo"
            (dateChange)="onEndDateChange($event)"
            matEndDate
            placeholder="End date"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        @if (creationDateFrom || creationDateTo) {
          <button
            (click)="clearDates()"
            mat-icon-button
            matSuffix
            aria-label="Clear dates"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
    @if (canGeneratePhotoReport()) {
      <div class="report-actions">
        <button
          class="large-report-btn"
          (click)="generatePicturesReport()"
          [disabled]="!photos.length"
          mat-button
          color="primary"
        >
          <mat-icon>description</mat-icon>
          GENERATE PICTURES REPORT
        </button>
      </div>
    }    
    @if (!noPicturesAfterLoading()) {
      <div class="display-mode">
        @for (photo of photos; track photo) {
          <div>
            <mat-card class="photo-card" appearance="outlined">
              <div class="photo-container">
                <img
                  class="hand-cursor"
                  [src]="photo.photo"
                  (click)="openViewPhotoDialog(photo.filename)"
                  (keydown)="handleKeyDown($event, photo.filename)"
                  alt=""
                />
              </div>
              <div class="photo-footer">
                @if (allowSharePictures()) {
                  <div>
                    <span>Shared</span
                    ><mat-slide-toggle
                      [checked]="photo.shared"
                      (change)="onSharePhoto($event, photo)"
                    ></mat-slide-toggle>
                  </div>
                }
                @if (canDownloadOrDeletePictures()) {
                  <div>
                    <mat-icon class="download" (click)="downloadImage(photo)"
                      >get_app</mat-icon
                    >
                    <mat-icon class="delete" (click)="deleteImage(photo)"
                      >clear</mat-icon
                    >
                  </div>
                }
              </div>
            </mat-card>
          </div>
        }
      </div>
    } @else {
      <div class="noPicturesMessageContainer">
        <span class="noPicturesMessage">
          <mat-icon>sentiment_dissatisfied</mat-icon>
          @if (selectedTags.value.length) {
            No images found for the selected tags.
          } @else {
            There are no pictures yet.
          }
        </span>
      </div>
    }
  </div>
} @else {
  <mat-spinner diameter="32"></mat-spinner>
}

@if (showDownloadButton()) {
  <comat-fab-speed-dial
    id="downloadAllPictures"
    [actions]="speedDialActions"
    (selectedAction)="onFabSpeedDialSelectedAction($event)"
    (stateChanged)="onFabSpeedDialStateChanged($event)"
    mainIcon="download"
    color="accent"
  >
  </comat-fab-speed-dial>
}
@if (showUploadButton()) {
  <button
    class="upload-button"
    id="deleteAllPictures"
    [attr.style]="getUploadButtonStyle()"
    [ngStyle]="{ bottom: uploadButtonBottomMargin + 'px !important' }"
    (click)="uploadPictures()"
    mat-fab
    color="accent"
  >
    <mat-icon>cloud_upload</mat-icon>
  </button>
}
